module.exports = __webpack_public_path__ + "assets/configuration-expert-icon.9567b1cf.svg";